import { exists } from '@/api'

export interface BibliographySetDetailMarc {
  marcTag: string
  stringLength: number
  data: string
}

export function BibliographySetDetailMarcFromJSON(
  json: any
): BibliographySetDetailMarc {
  return {
    marcTag: exists(json, 'marc_tag') ? json.marc_tag : '',
    stringLength: exists(json, 'string_length') ? json.string_length : 0,
    data: exists(json, 'data') ? json.data : ''
  }
}
